import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import './cart.scss';
import uuid from 'react-uuid';
import LoadingAnimation from '../../components/loadinganimation';
import ErrorAlert from '../../components/alertmessages';
import sHelpers from '../../modules/helpers/statichelpers';
import Config from '../../data/SiteConfig';
let serviceType = '';
let guestLoggedIn = false;
let urlPattern = '';
class CartDetail extends Component {

    constructor(props) {
        super(props)
        this.goCart = this.goCart.bind(this);
        this.goBill = this.goBill.bind(this);
        this.state = {
            showHide: false,
            getMenus: this.props.getMenus,
            getItems: this.props.getItems,
            loading: false,
            alertMessage: '',
            msgType: '',
            msgShow: false,
            userSessionId:this.props.userSessionId
        }
    }

    componentWillMount() {
       
        serviceType = sessionStorage.getItem('user-servicetype');
        guestLoggedIn = sessionStorage.getItem('user-loggedin') == null ? "false" : sessionStorage.getItem('user-loggedin');
        urlPattern =   sessionStorage.getItem('url-pattern');
        if (!urlPattern) {        
            this.props.history.push('/qrcodeerror' + Config.defaultUrlPattern);
            return false;
          }
    }

    goCart() {              
        /// user Session Validation        
        if (!sHelpers.userSessionValidation(this.props.userSessionId)) {
            this.showMessage("Your session has been expired, please try again", "danger");          
            setTimeout(() => {          
              window.location.reload(true);
            }, Config.minMsgTimeout);
            return false;
        }

        if (this.props.totalItems === 0) {
            this.showMessage("Cart is Empty", "danger");
            return false;
        }
        this.setState({ loading: true });
        sessionStorage.setItem('user-vendorOrderId', uuid());
        setTimeout(() => {
            this.setState({ loading: false });
            this.props.history.push('/cart' + urlPattern);
        }, 1200);
    }
    goBill() {
        if (guestLoggedIn === "true") {
            this.setState({ loading: true });
            setTimeout(() => {

                this.setState({ loading: false });
                this.props.history.push('/mybills' + urlPattern);
            }, Config.minMsgTimeout);
        }
        else {
            this.setState({ loading: true });
            sessionStorage.setItem("login-page-session", 7); // PayBill        
            setTimeout(() => {
                this.setState({ loading: false });
                this.props.history.push('/login' + urlPattern);
            }, Config.minMsgTimeout);
            return false;
        }
    }

    showMessage(msg, type) {
        window.scrollTo(0, 0);
        this.setState({ msgShow: true });
        this.setState({ msgType: type });
        this.setState({ alertMessage: msg });
        this.setState({ loading: false });
        setTimeout(() => {
            this.setState({ msgShow: false });
        }, Config.minMsgTimeout);
    };
    render() {
        return (
            <div>
                {this.state.loading && <LoadingAnimation />}
                {this.state.msgShow && <ErrorAlert alertMsg={this.state.alertMessage} msgType={this.state.msgType} msgShow={this.state.msgShow} />}
                {serviceType !== 'FINE-DINE' &&
                    <div className="cart-div" onClick={this.goCart} style={{ display: this.props.active }}>
                        <div className="c-left"> <span>{this.props.totalItems} </span> Items | ₹<span>{this.props.totalAmount.toFixed(2)}</span></div>
                        <div className="c-right">View Cart <span style={{ color: "#000" }}><i className="fa fa-shopping-cart"></i></span></div>
                    </div>
                }
                {serviceType === 'FINE-DINE' &&
                    <div className="cart-div">
                        {/* {!this.props.checkOutTypewithPay &&
                            <div className="c-left" onClick={this.goBill} ><span><img src="../assets/theme1/img/pay-bill.png" alt="lucid-post-paid" className="pay-bill-img" /></span><span>View Bill</span></div>
                        }
                        {this.props.checkOutTypewithPay &&
                            <div className="c-left" onClick={this.goBill} ><span><img src="../assets/theme1/img/pay-bill.png" alt="lucid-post-paid" className="pay-bill-img" /></span><span>Pay Bill</span></div>
                        } */}

                        <div className="c-center" onClick={this.goCart} ><span style={{ color: "#000" }}><i className="fa fa-shopping-cart"></i></span> Place Order ( {this.props.totalItems} )
                        </div>
                    </div>
                }

            </div>
        )
    }
}
export default withRouter(CartDetail)